var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar-login'),_c('div',{staticClass:"login"},[_c('LoginCard',{attrs:{"title":_vm.title,"subtitle":_vm.$t('login.subtitle'),"text":_vm.$t('login.text'),"buttonText":_vm.$t('login.buttonText')},on:{"click":_vm.onLoginClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }